<template>
  <BlokkliProvider v-slot="{ entity }" v-bind="blokkliProps" :entity="props">
    <div>
      <Hero
        v-if="hero"
        :media="hero"
        :title="title"
        :lead="lead"
        is-landing
        is-home
      />
      <Container v-else class="mx-auto grid-container">
        <div
          class="col-span-4 sm:col-span-6 md:col-span-6 md:col-start-2 lg:col-span-8 lg:col-start-3"
        >
          <h1
            v-blokkli-editable:title
            class="pb-3 text-4xl lg:pb-6 lg:text-7xl pt-20"
          >
            {{ entity?.title || title }}
          </h1>

          <div v-if="lead">
            <div class="pb-10">
              <div
                v-blokkli-editable:field_lead
                class="text-xl md:text-3xl leading-6 md:leading-10 md:font-bold"
                v-html="entity?.lead || lead"
              />
            </div>
          </div>
        </div>
      </Container>
    </div>
    <div
      v-if="mainMenuLinks && mainMenuLinks.length"
      id="main"
      class="bg-gray-50 pt-20 pb-26"
    >
      <Container>
        <h2 class="font-book text-xl lg:text-3xl pb-12">
          {{ $texts('landing.quicklinks') }}
        </h2>
        <MenuList>
          <MenuListLandingItem
            v-for="(child, key) in mainMenuLinks.slice(0, 4)"
            :key="key"
            :href="child.href"
            :label="child.label"
            :icon="child.icon"
          />
        </MenuList>
      </Container>
    </div>
    <div>
      <BlokkliField :list="paragraphs" name="field_paragraphs" />
    </div>
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import type { NodePageFragment } from '#graphql-operations'

const { mainMenuLinks } = useInitData()

const props = defineProps<NodePageFragment>()
</script>
